import './link.css';

function Link () {
    return (

        <section className="trial-block shadow3" id="ContactUs">
                    <div className="height450">
                       <div className="section-title text-center">
                          <span className="badge badge-info"></span>

                          <span className="section-title-line section-title-line"></span>
                       </div>
                        <div className="social-overlap process-scetion mt100">
                         <div className="container">
                             <div className="row justify-content-center">
                                 <div className="col-md-10">
                                     <div className="social-bar">
                                         <div className="social-icons mb-3 iconpad text-center">
                                        
                                             <a href="https://api.whatsapp.com/send?phone=5561996447022&text=Ol%C3%A1,%20vim%20pelo%20seu%20portf%C3%B3lio!" target="_blank" className="slider-nav-item"><i className="fa fa-whatsapp" aria-hidden="true"></i></a>
                                             <a href="https://www.instagram.com/pharaujo76/" target="_blank" className="slider-nav-item"><i className="fa fa-instagram" aria-hidden="true"></i></a>
                                             <a href="https://www.linkedin.com/in/pedro-henrique-lima18/" target="_blank" className="slider-nav-item"><i className="fa fa-linkedin" aria-hidden="true"></i></a>                             
                                             <a href="https://github.com/pedroaraujo76" target="_blank" className="slider-nav-item"><i className="fa fa-github" aria-hidden="true"></i></a>                             
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                    </div> 
           </section>
    )
}

export default Link 